<style>
    .available-shortcuts {
        flex: 1;
    }

    .available-shortcuts .mb-3 {
        margin-bottom: 10px;
    }
</style>
<ws-modal-wrapper headerLabel="Shortcut Settings"
                  acceptLabel="Save"
                  cancelLabel="Close"
                  [loading]="loading"
                  [excludeModalStyling]="true"
                  (save)="saveAndClose()"
                  (cancel)="bsModalRef.hide()">
    @if (!loading) {
    <div>
            <div class="mb-4">
                <label>Title</label>
                <input type="text" class="form-control" maxlength="50" placeholder="Title" [(ngModel)]="settings.title">
            </div>
            <div class="checkbox">
                <label>
                    <input type="checkbox" [(ngModel)]="settings.groupByType"> Group by Type
                </label>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center;">
                <div class="available-shortcuts">
                    <div>
                        <label>Action Views</label>
                        <div class="mb-4">
                            <select multiple
                                    class="form-select form-select-sm"
                                    [(ngModel)]="selectedActionViews"
                                    style="height: 125px;">
                                @for (item of actionViews; track item) {
                                    <option [ngValue]="item">
                                        @if (item.isSystemSearch) {
                                            <strong>System -</strong>
                                        }
                                        @if (!item.isSystemSearch) {
                                            <strong>User -</strong>
                                        }
                                        {{ item.name }}
                                    </option>
                                }
                            </select>
                        </div>
                    </div>
                    <div>
                        <label>SMART Searches</label>
                        <div class="mb-4">
                            <select multiple
                                    class="form-select form-select-sm"
                                    [(ngModel)]="selectedSmarts"
                                    style="height: 125px;">
                                @for (item of smarts; track item) {
                                    <option [ngValue]="item">
                                        @if (item.isSystemSearch) {
                                            <strong>System -</strong>
                                        }
                                        @if (!item.isSystemSearch) {
                                            <strong>User -</strong>
                                        }
                                        {{ item.name }}
                                    </option>
                                }
                            </select>
                        </div>
                    </div>
                    @if (canViewReports) {
                        <div>
                            <label>Reports</label>
                            <div class="mb-4">
                                <select multiple
                                        class="form-select form-select-sm"
                                        [(ngModel)]="selectedReports"
                                        style="height: 125px;">
                                    @for (item of reports; track item) {
                                        <option [ngValue]="item">
                                            @if (item.categoryId === 100) {
                                                <strong>System -</strong>
                                            }
                                            @if (item.categoryId !== 100) {
                                                <strong>User -</strong>
                                            }
                                            {{ item.name }}
                                        </option>
                                    }
                                </select>
                            </div>
                        </div>
                    }
                </div>
                <button class="has-icon btn" style="margin: 15px;" (click)="addShortcuts()">
                    <i class="fa fa-arrow-right"></i></button>
                <ul class="list-group"
                    style="flex: 1; height: 450px; border: 1px solid var(--ace-neutral-300); border-radius: 10px; margin-bottom: 0; overflow-y: auto;">
                    @for (item of addedShortcuts; track item) {
                        <li class="list-group-item" style="display: flex;">
                            <div style="flex: 1;">{{ item.name }}</div>
                            <div (click)="removeShortcut(item)"><i class="fa fa-close"></i></div>
                        </li>
                    }
                </ul>
            </div>
        </div>
    }
</ws-modal-wrapper>
